import { defineExperiment } from '@cian/experiments/ab';

import { AUD_WEB_BX1122_PIN_UNIFICATION } from './experiments';

export const ExpPinsAndPopupRedesign = defineExperiment(AUD_WEB_BX1122_PIN_UNIFICATION, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
